module.exports = __webpack_public_path__ + "img/banner01080219.cf4f2c7b.png";